export enum CountryStatus {
  notStarted = 'notStarted',
  editing = 'editing',
  review = 'review',
  approval = 'approval',
  accepted = 'accepted',
}
